// about section 1 image anim
if (
  typeof document.getElementsByClassName(".co-about-section-1-image") !=
    "undefined" &&
  document.getElementsByClassName(".co-about-section-1-image") != null
) {
  if (window.matchMedia("(max-width: 749px)").matches) {
    imageScrollScaleReverseFade(
      ".co-about-section-1-image img",
      ".co-about-section-1",
      "140%",
      null,
      1,
      0.5
    );
  } else {
    imageScrollScaleReverseFade(
      ".co-about-section-1-image img",
      ".co-about-section-1",
      "110%",
      null,
      1,
      0.5
    );
  }
}
// imageScrollScaleReverseFade('.co-contact-section-1-image img', '.co-contact-section-1');

// about section 6 image anim
if (
  typeof document.getElementsByClassName(".co-about-section-6-frame--image") !=
    "undefined" &&
  document.getElementsByClassName(".co-about-section-6-frame--image") != null
) {
  imageScrollScale(
    ".co-about-section-6-frame--image .image-2",
    ".co-about-section-6",
    "25%",
    null,
    0,
    1.1
  );
}
// faq section 2 image anim
if (
  typeof document.getElementsByClassName(".co-faq-section-2-image") !=
    "undefined" &&
  document.getElementsByClassName(".co-faq-section-2-image") != null
) {
  imageScrollScale(
    ".co-faq-section-2-image img",
    "co-faq-section-2",
    null,
    null,
    null,
    1.3
  );
}

// if (typeof (document.getElementsByClassName('.co-home-section-7')) != 'undefined' && document.getElementsByClassName('.co-home-section-7') != null) {

//     imageScrollScale('.co-home-section-7-image .img-2', '.co-home-section-7', null, null, 0.5, 1.1);
//     imageScrollScaleReverse('.co-home-section-7-image .img-1', '.co-home-section-7', null, null, 0.5, 1.1);

// }
let coSec7 = document.querySelectorAll(".co-home-section-7");
coSec7.forEach(function (coSec7Item) {
  if (coSec7Item) {
    var coSec7ItemImg2 = coSec7Item.querySelectorAll(".img-2");
    var coSec7ItemImg1 = coSec7Item.querySelectorAll(".img-1");

    imageScrollScale(coSec7ItemImg2, coSec7Item, null, null, 0.5, 1.1);
    imageScrollScaleReverse(coSec7ItemImg1, coSec7Item, null, null, 0.5, 1.1);
  }
});
// Home section 4 image anim
if (
  typeof document.getElementsByClassName(".co-home-section-4") != "undefined" &&
  document.getElementsByClassName(".co-home-section-4") != null
) {
  imageScrollScale(
    ".co-home-section-4-image img",
    ".co-home-section-4",
    "15%",
    "bottom bottom",
    0.5,
    1
  );
}

if (
  typeof document.getElementsByClassName(".co-home-section-5") != "undefined" &&
  document.getElementsByClassName(".co-home-section-5") != null
) {
  imageScrollScale(
    ".co-home-section-5-image--left img",
    ".co-home-section-5",
    "25%",
    "bottom bottom",
    1,
    1.2
  );
  imageScrollScale(
    ".co-home-section-5-image--right img",
    ".co-home-section-5",
    "25%",
    "bottom bottom",
    1.2,
    1
  );
}

function imageScrollScale(
  target,
  trigger,
  triggerPosStart,
  triggerPosEnd,
  scaleFrom,
  scaleTo
) {
  // default paramaters
  target = target || false;
  trigger = trigger || false;
  triggerPosStart = triggerPosStart || "top";
  triggerPosEnd = triggerPosEnd || "bottom";
  scaleFrom = scaleFrom || 0.1;
  scaleTo = scaleTo || 1;

  gsap.set(target, { scale: scaleFrom });
  gsap.to(target, {
    scrollTrigger: {
      trigger: trigger,
      toggleActions: "restart none none reverse",
      // markers: true,
      start: "" + triggerPosStart + " bottom",
      end: "" + triggerPosEnd + " top",
      scrub: true,
    },
    scale: scaleTo,
  });
}

function imageScrollScaleReverse(
  target,
  trigger,
  triggerPosStart,
  triggerPosEnd,
  scaleFrom,
  scaleTo
) {
  // default paramaters
  target = target || false;
  trigger = trigger || false;
  triggerPosStart = triggerPosStart || "top";
  triggerPosEnd = triggerPosEnd || "bottom";
  scaleFrom = scaleFrom || 0.1;
  scaleTo = scaleTo || 1;

  gsap.set(target, { scale: scaleTo });
  gsap.to(target, {
    scrollTrigger: {
      trigger: trigger,
      toggleActions: "restart none none reverse",
      // markers: true,
      start: "" + triggerPosStart + " bottom",
      end: "" + triggerPosEnd + " top",
      scrub: true,
    },
    scale: scaleFrom,
  });
}

function imageScrollScaleReverseFade(
  target,
  trigger,
  triggerPosStart,
  triggerPosEnd,
  scaleFrom,
  scaleTo
) {
  // default paramaters
  target = target || false;
  trigger = trigger || false;
  triggerPosStart = triggerPosStart || "top";
  triggerPosEnd = triggerPosEnd || "bottom";
  scaleFrom = scaleFrom || 1;
  scaleTo = scaleTo || 0.2;

  gsap.set(target, { scale: scaleFrom, opacity: 1 });
  gsap.to(target, {
    scrollTrigger: {
      trigger: trigger,
      toggleActions: "restart none none reverse",
      // markers: true,
      start: "" + triggerPosStart + " bottom",
      end: "" + triggerPosEnd + " top",
      scrub: true,
    },
    scale: scaleTo,
    opacity: 0,
  });
}

// gsap.set('.co-about-section-4-intro-text h2 span', { opacity: 0 });
// gsap.to('.co-about-section-4-intro-text h2 span', {
//     scrollTrigger: {
//         trigger: '.co-about-section-4-intro-text',
//         toggleActions: "restart none none reverse",
//         // markers: true,
//         start: "20% bottom",
//         end: "-20% top",
//         scrub: true
//     },
//     opacity: 1,
//     stagger: 0.3,
// });

if (
  typeof document.getElementsByClassName(".co-home-section-6-image") !=
    "undefined" &&
  document.getElementsByClassName(".co-home-section-6-image") != null
) {
  let homeSect6ImgHeight = gsap.getProperty(
    ".co-home-section-6-image",
    "height"
  );
  gsap.to(".co-home-section-6-image--textover", {
    scrollTrigger: {
      trigger: ".co-home-section-6-image",
      start: "3% bottom",
      end: "bottom top",
      // markers: true,
      scrub: true,
    },
    y: homeSect6ImgHeight * 0.75,
    scale: 1.5,
  });
}

if (
  typeof document.getElementsByClassName(".co-about-section-1") !=
    "undefined" &&
  document.getElementsByClassName(".co-about-section-1") != null
) {
  if (window.matchMedia("(max-width: 749px)").matches) {
    let aboutSect1Height = gsap.getProperty(".co-about-section-1", "height");
    gsap.set(".co-about-section-1-text", {
      y: aboutSect1Height * 0.1,
      opacity: 0,
    });
    gsap.to(".co-about-section-1-text", {
      scrollTrigger: {
        trigger: ".co-about-section-1",
        start: "top top",
        end: "90% top",
        // markers: true,
        scrub: true,
      },
      opacity: 1,
      y: aboutSect1Height * 0.75,
      force3D: false,
      // scale: 1.2
    });
  } else {
    let aboutSect1Height = gsap.getProperty(".co-about-section-1", "height");
    gsap.set(".co-about-section-1-text", {
      y: aboutSect1Height * 0.1,
      opacity: 0,
    });
    gsap.to(".co-about-section-1-text", {
      scrollTrigger: {
        trigger: ".co-about-section-1",
        start: "0% top",
        end: "bottom top",
        // markers: true,
        scrub: true,
      },
      opacity: 1,
      y: aboutSect1Height * 0.7,
      force3D: false,
      // scale: 1.2
    });
  }
}

// if (typeof (document.querySelector('.logo--sticky_home')) != 'undefined' && document.querySelector('.logo--sticky_home') != null) {

//     gsap.to('.logo--sticky_home', {
//         scrollTrigger: {
//             trigger: ".co-home-section-2",
//             start: "top top",
//             end: "100% top",
//             onEnter: () => {
//                 document.querySelector(".logo--sticky_home").classList.add("active");
//             },
//             onLeaveBack: () => {
//                 document.querySelector(".logo--sticky_home").classList.remove("active");
//             },
//         }
//     });
// }

if (
  typeof document.getElementsByClassName(".co-product-section-2-image") !=
    "undefined" &&
  document.getElementsByClassName(".co-product-section-2-image") != null
) {
  if (window.matchMedia("(max-width: 749px)").matches) {
    imageScrollScaleReverseFade(
      ".co-product-section-2-image img",
      ".co-product-section-2",
      "140%",
      null,
      1,
      0.5
    );
  } else {
    imageScrollScaleReverseFade(
      ".co-product-section-2-image img",
      ".co-product-section-2",
      "110%",
      null,
      1,
      0.5
    );
  }
}

if (
  typeof document.getElementsByClassName(".co-product-section-2") !=
    "undefined" &&
  document.getElementsByClassName(".co-product-section-2") != null
) {
  if (window.matchMedia("(max-width: 749px)").matches) {
    let aboutSect1Height = gsap.getProperty(".co-product-section-2", "height");
    gsap.set(".co-product-section-2-text", {
      y: aboutSect1Height * 0.1,
      opacity: 0,
    });
    gsap.to(".co-product-section-2-text", {
      scrollTrigger: {
        trigger: ".co-product-section-2",
        start: "100% bottom",
        end: "bottom top",
        // markers: true,
        scrub: true,
      },
      opacity: 1,
      y: aboutSect1Height * 0.55,
      force3D: false,
      // scale: 1.2
    });
  } else {
    let aboutSect1Height = gsap.getProperty(".co-product-section-2", "height");
    gsap.set(".co-product-section-2-text", {
      y: aboutSect1Height * 0.1,
      opacity: 0,
    });
    gsap.to(".co-product-section-2-text", {
      scrollTrigger: {
        trigger: ".co-product-section-2",
        start: "0% top",
        end: "bottom top",
        // markers: true,
        scrub: true,
      },
      opacity: 1,
      y: aboutSect1Height * 0.7,
      force3D: false,
      // scale: 1.2
    });
  }
}

gsap.to(".co-featured-article--logo", {
  repeat: -1,
  rotateY: 360,
  ease: "none",
  duration: 8,
  delay: 0.25,
});
